import { getIsDismissed } from '@ms/yammer-data/dist/domains/browserDeprecation/selectors';

import { useSelector } from '../useSelector';

type UseIsDismissed = () => ReturnType<typeof getIsDismissed>;
export const useIsDismissed: UseIsDismissed = () => useSelector(getIsDismissed);
